import { InferType, object, string } from 'yup';

export const googleServiceAccountKeySchema = object({
  type: string().matches(/service_account/).required(),
  // eslint-disable-next-line camelcase
  client_email: string().email().required(),
  // eslint-disable-next-line camelcase
  private_key: string().required(),
  // eslint-disable-next-line camelcase
  private_key_id: string().required()
});

export type GoogleServiceAccountKey = InferType<typeof googleServiceAccountKeySchema>;
